import { ShieldOff } from 'lucide-react';
import { useI18n } from '@/context/I18nContext';
import { useAuth } from '@/context/AuthContext';

export function AccessDeniedPage() {
  const { t } = useI18n();
  const { signOut, user } = useAuth();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6">
      <div className="card p-10 text-center max-w-md">
        <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-6">
          <ShieldOff size={28} className="text-red-500" />
        </div>
        <h1 className="text-xl font-semibold text-text-primary mb-2">{t('users.accessDenied')}</h1>
        <p className="text-sm text-text-secondary mb-2">{t('users.accessDeniedMessage')}</p>
        {user && (
          <p className="text-xs text-text-muted mb-6 mono">{user.email}</p>
        )}
        <button
          onClick={signOut}
          className="px-4 py-2 rounded-md text-sm font-medium text-text-secondary border border-border-default hover:border-red-500/50 hover:text-red-500 transition-colors cursor-pointer"
        >
          {t('auth.signOut')}
        </button>
      </div>
    </div>
  );
}
